import AppHeaderContainer from './container'

export default AppHeaderContainer
